import React from 'react';
import { PrematchContext } from '../Prematch';
import Stats from '../../common/Stats';

function Statistics(props) {
    const prematchContext = React.useContext(PrematchContext);

    return (    
        <div className="overlay-container">
            <Stats url={prematchContext.statsUrl} />        
        </div>
    );
}
export default Statistics;